import PropTypes from 'prop-types';

import ThemeCustomization from 'src/themes';
import Locales from 'src/components/ui/Locales';
import { ConfigProvider } from 'src/contexts/ConfigContext';
import { InterfaceProvider } from 'src/contexts/InterfaceContext';

const UIProviders = (props) => {
	const { children, isDev } = props;
	return (
		<ConfigProvider isDev={isDev}>
			<Locales>
				<InterfaceProvider>
					<ThemeCustomization>{children}</ThemeCustomization>
				</InterfaceProvider>
			</Locales>
		</ConfigProvider>
	);
};

UIProviders.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.arrayOf(PropTypes.node),
	]),
	isDev: PropTypes.bool,
};
export default UIProviders;
